import { ref, watch } from 'vue'

export function useSwipe(handleSwipe?: ({ direction }: { direction: string }) => void | null) {
  const swipe = ref<{
    verticalScrollLock: boolean
    touchStartX: number | null
    touchStartY: number | null
  }>({
    verticalScrollLock: false,
    touchStartX: null,
    touchStartY: null,
  })

  watch(
    () => swipe.value.verticalScrollLock,
    (newVal, oldVal) => {
      if (newVal !== oldVal) {
        const querySelectorBody = document.querySelector('body') as HTMLElement
        if (newVal) {
          querySelectorBody.style.overflow = 'hidden'
        } else {
          querySelectorBody.style.overflow = 'auto'
        }
      }
    },
  )

  function swipeStart(e: TouchEvent) {
    if (e && e.changedTouches) {
      swipe.value.touchStartX = e.changedTouches[0].screenX
      swipe.value.touchStartY = e.changedTouches[0].screenY
    }
  }

  function swipeMove(e: TouchEvent) {
    if (
      swipe.value.touchStartX &&
      swipe.value.touchStartY &&
      e &&
      e.changedTouches &&
      !swipe.value.verticalScrollLock
    ) {
      const touchEndX = e.changedTouches[0].screenX
      const touchEndY = e.changedTouches[0].screenY
      const diffX = Math.abs(touchEndX - swipe.value.touchStartX)
      const diffY = Math.abs(touchEndY - swipe.value.touchStartY)
      if (diffX > diffY) {
        e.preventDefault()
        if (swipe.value.touchStartX < touchEndX) {
          swipe.value.verticalScrollLock = true
        }
        if (swipe.value.touchStartX > touchEndX) {
          swipe.value.verticalScrollLock = true
        }
      }
    }
  }

  function swipeEnd(e: TouchEvent) {
    if (swipe.value.touchStartX && swipe.value.touchStartY && e && e.changedTouches) {
      const touchEndX = e.changedTouches[0].screenX
      const touchEndY = e.changedTouches[0].screenY
      const diffX = Math.abs(touchEndX - swipe.value.touchStartX)
      const diffY = Math.abs(touchEndY - swipe.value.touchStartY)
      if (diffX > diffY) {
        // swipe right, defined by component
        if (swipe.value.touchStartX < touchEndX && handleSwipe) {
          handleSwipe({
            direction: 'right',
          })
        }
        // swipe left, defined by component
        if (swipe.value.touchStartX > touchEndX && handleSwipe) {
          handleSwipe({
            direction: 'left',
          })
        }
      }
    }

    // clear start
    swipe.value.touchStartX = null
    swipe.value.touchStartY = null
    // remove scroll lock
    swipe.value.verticalScrollLock = false
  }

  return {
    swipe,
    swipeStart,
    swipeMove,
    swipeEnd,
  }
}
